<app-user-header></app-user-header>
<app-user-navigation></app-user-navigation>
<div class="main-panel">
  <router-outlet></router-outlet>
</div>
<app-user-footer></app-user-footer>